<template>
  <div class="my-2 flex items-center">
    <div>
      <div
        class="viewing"
        :class="[
          video.viewing_percentage === 100 ? viewingFull : viewingNormal,
        ]"
      >
        Visto {{ video.viewing_percentage }} %
      </div>
    </div>
  </div>
</template>

<script>
import videoListItemContentMixin from '@/mixins/videoListItemContentMixin'

export default {
  mixins: [videoListItemContentMixin],

  data() {
    return {
      viewingNormal: 'viewing-normal',
      viewingFull: 'viewing-full',
    }
  },
}
</script>

<style scoped>
.viewing {
  @apply px-3 py-1 text-sm border border-secondary-500 rounded-full;
}

.viewing-normal {
  @apply text-secondary-500;
}

.viewing-full {
  @apply bg-secondary-500 text-white;
}
</style>
